'use strict';

customerZone

    .controller('UsageHistoryController', ['$log', '$q', '$filter', '$rootScope', '$scope', '$timeout', 'utils',
        'Session', 'UnleashedClient', 'config', function($log, $q, $filter, $rootScope, $scope, $timeout, utils,
        session, api, config) {

            var self = this;
            self.history = [];

            self.isPostpaidOnTransatel = session.flags('postpaid_on_transatel');

            self.filterTypes = [
                'all',
                'voice',
                'sms',
                'data'
            ];

            var defaultFromDate = moment().startOf('day').subtract(1, 'year');
            var defaultToDate = moment().startOf('day').add(1, 'day');

            var loadUsageRecordsPromise;

            /**
             * Initialising filters
             * dateFrom contains a function returning the day one month before today.
             * @type {{type: string, dateFrom: string, dateTo: string, perPage: string}}
             */
            self.filter = {
                type: 'all',
                dateFrom: defaultFromDate,
                dateTo: defaultToDate,
                paidOnly: false
            };

            self.today = moment();

            self.icon = function(line){
                if (line.type === 'data') return 'data';
                if (line.type === 'voice' && line.isIncoming) return 'call_in';
                if (line.type === 'voice' && !line.isIncoming) return 'call_out';
                if (line.type === 'sms' && line.isIncoming) return 'sms_in';
                if (line.type === 'sms' && !line.isIncoming) return 'sms_out';
            };

            var matchesFilterCriteria = function(record){
                if (!['all', record.type].includes(self.filter.type)) return false;
                if (self.filter.paidOnly && record.price === 0) return false;
                return true;
            };

            var fixFilters = function(){
                if (!self.filter.dateFrom)
                    self.filter.dateFrom = defaultFromDate;
                if (!self.filter.dateTo)
                    self.filter.dateTo = defaultToDate;
                if (self.filter.dateTo.isBefore(self.filter.dateFrom)) {
                    var temp = self.filter.dateTo;
                    self.filter.dateTo = self.filter.dateFrom;
                    self.filter.dateFrom = temp;
                }
            };

            self.loadTotals = function(){
                self.usageTotal = undefined;
                fixFilters();
                return api.getUsageTotals(session.subscriber().id, self.filter)
                    .then(function(totals){
                        self.usageTotal = totals;
                    })
                    .catch(function(e){
                        $log.error('Failed to load usage total', e);
                        utils.showError();
                    });
            };

            self.loadUsageRecords = function(nextPage){
                var retrieverFn = function(page) {
                    fixFilters();
                    return api.getUsageHistory(session.subscriber().id, self.filter, page)
                        .catch(function (error) {
                            $log.error('failed to load usage history', error);
                            return [];
                        });
                };

                loadUsageRecordsPromise = filteredSearch(nextPage, retrieverFn, matchesFilterCriteria);
                return loadUsageRecordsPromise;
            };

            /**
             * Retrieve filtered results from a retriever function, automatically continuing if a page turns up empty.
             * @param page number Initial page to start looking
             * @param retrieverFn function(page) a retriever function that will return results for the given page
             * @param filterFn function(record) a filter function that will return true/false to filter the records
             * @return {Array} a promise to a paged array containing the next records.  Empty means no records are left.
             */
            var filteredSearch = function(page, retrieverFn, filterFn){
                return retrieverFn(page).then(function(retrievedPage){
                    var filtered = retrievedPage.filter(filterFn);
                    filtered.paging = retrievedPage.paging;
                    if (filtered.length > 0) return filtered;
                    if (filtered.paging && filtered.paging.next)
                        return filteredSearch(filtered.paging.next, retrieverFn, filterFn);
                    return filtered;
                });
            };

            self.exportPdf = function(){
                var filename = utils.format('jim_mobile__{from}_{to}', {
                    from: self.filter.dateFrom.format('YYYY-MM-DD'),
                    to: self.filter.dateTo.format('YYYY-MM-DD')
                });
                return loadPdfMake()
                    .then(loadAllData)
                    .then(function(data){
                        createUsagePdf(data, filename);
                    })
                    .catch(function (error) {
                        $log.error('failed to export all usage history', error);
                        utils.showError();
                    });

            };

            var loadPdfMake = function(){
                if (window.pdfMake) return $q.when();
                return loadLibrary('https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.37/pdfmake.min.js')
                    .then(function(){
                        return loadLibrary(config.baseUrl+'/lib/pdfmake/vfs_fonts.js');
                    });
            };

            var loadAllData = function(){
                fixFilters();
                return api.getUsageHistory(session.subscriber().id, self.filter, 1, 10000)
                    .then(function(records){
                        return records.filter(matchesFilterCriteria);
                    });
            };

            var createUsagePdf = function(data, filename){
                var title = utils.format('usage_extract_for_{from}_to_{to}', {
                    from: self.filter.dateFrom.format('YYYY-MM-DD'),
                    to: self.filter.dateTo.format('YYYY-MM-DD')
                });
                var header = [
                    {text: utils.translate('call_history_entry_type'), style: 'tableHeader'},
                    {text: utils.translate('call_history_entry_date'), style: 'tableHeader'},
                    {text: utils.translate('call_history_entry_from_or_to'), style: 'tableHeader'},
                    {text: utils.translate('call_history_entry_value'), style: 'tableHeader'},
                    {text: utils.translate('call_history_entry_quantity'), style: 'tableHeader'},
                    {text: utils.translate('call_history_entry_cost'), style: 'tableHeader'}
                ];
                var rows = data.map(function(entry){
                    return [
                        entry.type,
                        moment(entry.startDate.toDate()).format('DD/MM/YYYY HH:mm:ss'),
                        $filter('formatPhone')(entry.isIncoming ? entry.origin : entry.destination),
                        entry.time === 1 ? '-' : $filter('msToHMS')(entry.time),
                        entry.quantity === 0 ? '-' : $filter('formatBytes')(entry.quantity),
                        $filter('amountEuro')(entry.price || 0)
                    ];
                });
                rows.splice(0, 0, header);
                var dd = {
                    pageSize: 'A4',
                    header: {text: title, style: 'header'},
                    content: [
                        {table: {
                            headerRows: 1,
                            body: rows
                        }, layout: {
                            hLineColor: '#AAAAAA',
                            vLineColor: '#AAAAAA'
                        }}
                    ],
                    defaultStyle: {
                        font: 'museo',
                        alignment: 'center'
                    },
                    styles: {
                        header: {
                            alignment: 'center'
                        },
                        tableHeader: {
                            bold: true
                        }
                    }};

                pdfMake.fonts = {
                    museo: {
                        normal: 'MuseoSansRounded-300.woff',
                        bold: 'MuseoSansRounded-700.woff',
                        italics: 'MuseoSansRounded-300.woff',
                        bolditalics: 'MuseoSansRounded-700.woff'
                    }
                };
                pdfMake.createPdf(dd).download(filename);
            };

            var loadLibrary = function(url){
                return $q(function(resolve, reject){
                    var scriptNode = document.createElement('script');
                    scriptNode.type = 'text/javascript';
                    scriptNode.charset = 'utf-8';
                    scriptNode.src = url;
                    document.getElementsByTagName('head')[0].appendChild(scriptNode);
                    scriptNode.onload = resolve;
                    scriptNode.onerror = reject;
                });
            };

            function needsToScrollToBestTariffComponent() {
                var referrer = document.referrer;
                if (!referrer) return false;

                if ($rootScope.referrerAlreadyHandled) {
                    return false;
                }
                $rootScope.referrerAlreadyHandled = true;

                var baseReferrers = ['bestetarief.be', 'besttariff.be', 'meilleurtarif.be', 'bestertarif.be'];
                for (var i = 0, len = baseReferrers.length; i < len; ++i) {
                    var baseReferrer = baseReferrers[i];
                    if (referrer.startsWith('https://www.' + baseReferrer) ||
                        referrer.startsWith('https://' + baseReferrer) ) {
                        return true;
                    }
                }
                return false;
            }

            function scrollToFirst(selector, margin) {
                var element = document.querySelector(selector);
                if (!element) return;

                if ('scrollBehavior' in document.documentElement.style) {
                    window.scrollBy({top: Math.floor(element.getBoundingClientRect().top) - (margin || 0),
                        behavior: 'smooth'});
                }
                else {
                    window.scrollBy(0, (Math.floor(element.getBoundingClientRect().top) - (margin || 0)));
                }
            }

            self.loadTotals()
            .then(function() {
                return loadUsageRecordsPromise;
            })
            .then(function() {
                // $timeout without explicit time -> wait until the next digest cycle of Angular (i.e. when
                //  drawing of the UI - based on loadUsageRecordsPromise - was finished)
                $timeout(function() {
                    if (needsToScrollToBestTariffComponent()) {
                        scrollToFirst('#best-tariff');
                    }
                });
            });
        }
    ]);
